import { CalendarOff } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { SlotCard } from "@/components/booking/SlotCard";
import { SLOTS } from "@/lib/studio";

const ClosedBanner = ({ reason }) => (
  <div className="mb-5 flex items-center gap-3 rounded-md border border-[#FF8C00]/40 bg-[#FF8C00]/10 p-4 text-sm text-[#FFB866]" data-testid="closed-day-banner">
    <CalendarOff className="h-4 w-4 shrink-0" /> Studio closed this day{reason ? ` — ${reason}` : ""}.
  </div>
);

export const SlotList = ({ avail, slot, onSelect }) => {
  const isAvailable = (id) => avail?.slots.find((s) => s.id === id)?.available;
  return (
    <>
      {avail?.closed && <ClosedBanner reason={avail.closed_reason} />}
      <div className="space-y-3" data-testid="timeslot-list">
        {SLOTS.map((s) =>
          avail === null ? (
            <Skeleton key={s.id} className="h-[76px] w-full" />
          ) : (
            <SlotCard key={s.id} slot={s} available={isAvailable(s.id)} selected={slot === s.id} onSelect={onSelect} />
          )
        )}
      </div>
    </>
  );
};
